import { render, staticRenderFns } from "./TabelaPatrimonioPj.vue?vue&type=template&id=591f96b9&lang=pug"
import script from "./TabelaPatrimonioPj.vue?vue&type=script&lang=js"
export * from "./TabelaPatrimonioPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaPatrimonioPj.vue?vue&type=style&index=0&id=591f96b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports